import React, {useEffect} from 'react';
import CrewCartMember from "./CrewCartMember.jsx";

const Header = ({ crewCart, settings }) => {
    useEffect(() => {

        console.log("UPDATE SETTINGSSSS");
console.log({settings});
    }, [crewCart, settings]);

    // Check if custom slider button is enabled
    const useCustomLogo = settings?.use_custom_slider_button === true;

    return (
        <>
            <style>
                {`
                .header-container {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 10px 0;
                }

                .crewcart-members {
                    display: flex;
                    margin-left: -15px; /* Creates the overlap effect */
                }

                .crewcart-logo {
                    width: ${useCustomLogo ? '30px' : '100px'};
                    height: auto;
                }

                .crewcart-logo-container {
                    display: flex;
                    align-items: center;
                }

                .crewcart-logo-text {
                    font-family: ${settings?.slider_button_font_family || 'Arial, sans-serif'};
                    font-size: ${settings?.slider_button_font_size || 17}px;
                    font-weight: ${settings?.slider_button_font_weight || 'bold'};
                    margin-left: 8px;
                    white-space: nowrap;
                }

                .crewcart-members > * {
                    margin-left: -5px; /* Overlap for CrewCartMember components */
                }
                `}
            </style>

            <div className="header-container">
                <div className="crewcart-logo-container">
                    {useCustomLogo && settings?.slider_button_name ? (
                        // Custom logo enabled and name provided - use large icon with text
                        <>
                            <img
                                src="/images/crewcart_large_icon.png"
                                className="crewcart-logo"
                                alt="CrewCart"
                            />
                            <span className="crewcart-logo-text">
                                {settings.slider_button_name.length > 15
                                    ? settings.slider_button_name.substring(0, 15)
                                    : settings.slider_button_name
                                }
                            </span>
                        </>
                    ) : (
                        // Use default crewcart logo (either custom disabled or no name provided)
                        <img
                            src="/images/crewcart.png"
                            className="crewcart-logo"
                            alt="CrewCart"
                        />
                        )}
            </div>
                <div className="crewcart-members">
                    {crewCart?.members?.map((member, index) => (
                        <CrewCartMember
                            key={index}
                            name={member.name}
                            status={member.status}
                            size={35}
                        />
                    ))}
                </div>
            </div>
            <div className="bottom-border"></div>
        </>
    );
}

export default Header;
